import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  cardPreviewMenuIcon: {
    width: '22px',
    height: '22px',
    margin: '12px 5px',
    cursor: 'pointer',
  },
  cardPreviewMenuPages: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    top: '3px',
    margin: '10px',
    minWidth: '60px',
  },
  cardPreviewMenuCurrentPage: {
    position: 'relative',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '1em',

    color: '#81818D',
  },
  cardPreviewMenuTotalPages: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '1em',
    color: '#81818D',
    paddingLeft: '1px',
  },
  hr: {
    position: 'absolute',
    top: '13px',
    left: '-9px',
    width: '25px',
  },
  disabledAction: {
    position:'absolute',
    top: '8px', 
    left: '8px', 
    height:'25%',
    width:'25%',
    color:'black'
  },
}));
